/* LegBilligt — HERO-KARRUSELLEN PAA FORSIDEN
   Hoerer sammen med snippets/lb-hero-kar.liquid og assets/lb-hero-kar.css.

   Jakob 7. september: "vores hero om til en hero som skifter billede hver 8
   sekund for baade mobil og computer version. og at man kan skifte til
   slide hvis man ikke vil vente i 8 sekunder."

   Skifter altsaa af sig selv hvert 8. sekund (tallet staar i data-ms paa
   snippet'et, ikke her), og kan styres med pile, prikker og stryg.

   INGEN MutationObserver. Det er en staaende regel i projektet, og der er
   heller ingen grund: sliderne staar i HTML'en, naar filen koerer.

   Uret bliver stoppet fire steder, og hvert af dem har en grund:
     musen ind over    ellers skifter billedet, mens man sigter paa knappen
     tastaturfokus     ellers forsvinder det link, man er ved at naa
     fanen i baggrunden setInterval bliver alligevel strubet i baggrunden,
                       saa uden det her ville alle de ventende skift blive
                       afviklet paa én gang, naar fanen kommer frem
     bevaegelse fravalgt prefers-reduced-motion: reduce betyder ogsaa, at
                       ting ikke skal flytte sig af sig selv

   Et manuelt skift nulstiller uret (start() kaldes igen), saa man faar
   altid sine fulde 8 sekunder paa den slide, man selv har valgt. */

(function(){
  var kar = document.querySelector('[data-lbfk]');
  if (!kar) { return; }

  var slides = [].slice.call(kar.querySelectorAll('.lbfk-s'));
  var dots = [].slice.call(kar.querySelectorAll('.lbfk-dot'));

  /* Kun ét billede: skjul pile og prikker, og lad slide 1 staa.
     Den aktive slide har allerede klassen paa fra Liquid, saa der er intet
     at taende her. */
  if (slides.length < 2) {
    kar.classList.add('lbfk--enkelt');
    return;
  }

  var ms = parseInt(kar.getAttribute('data-ms'), 10) || 8000;
  var nu = 0;
  var ur = null;
  var roligt = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function vis(i){
    nu = (i + slides.length) % slides.length;

    slides.forEach(function(s, n){
      var paa = n === nu;
      s.classList.toggle('paa', paa);
      s.setAttribute('aria-hidden', paa ? 'false' : 'true');
      /* Links i en skjult slide maa ikke kunne tabbes til. display:none
         skjuler dem for de fleste browsere, men ikke alle, og en
         tastaturbruger, der lander paa et usynligt link, er faret vild. */
      [].forEach.call(s.querySelectorAll('a'), function(a){
        if (paa) { a.removeAttribute('tabindex'); } else { a.setAttribute('tabindex', '-1'); }
      });
    });

    dots.forEach(function(d, n){
      d.classList.toggle('paa', n === nu);
      d.setAttribute('aria-current', n === nu ? 'true' : 'false');
    });
  }

  function stop(){
    if (ur) { clearInterval(ur); ur = null; }
  }

  function start(){
    stop();
    if (roligt) { return; }
    ur = setInterval(function(){ vis(nu + 1); }, ms);
  }

  function haand(i){
    vis(i);
    start();
  }

  kar.addEventListener('click', function(e){
    var t = (e.target && e.target.closest) ? e.target.closest('[data-lbfk-gaa]') : null;
    if (!t) { return; }
    e.preventDefault();
    var v = t.getAttribute('data-lbfk-gaa');
    if (v === 'frem') { haand(nu + 1); }
    else if (v === 'tilbage') { haand(nu - 1); }
    else { haand(parseInt(v, 10) || 0); }
  });

  kar.addEventListener('mouseenter', stop);
  kar.addEventListener('mouseleave', start);
  kar.addEventListener('focusin', stop);
  kar.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', function(){
    if (document.hidden) { stop(); } else { start(); }
  });

  /* Stryg paa telefon. Kravet om 1,6 gange mere vandret end lodret er der,
     saa en almindelig rulning ned gennem forsiden ikke bliver laest som et
     stryg. Begge lyttere er passive, saa de ikke bremser rulningen. */
  var x0 = null, y0 = null;
  kar.addEventListener('touchstart', function(e){
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
  }, {passive:true});
  kar.addEventListener('touchend', function(e){
    if (x0 === null) { return; }
    var dx = e.changedTouches[0].clientX - x0;
    var dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.6) {
      haand(dx < 0 ? nu + 1 : nu - 1);
    }
  }, {passive:true});

  /* HASTIGHED: billederne i de skjulte slides staar som loading="lazy" i
     HTML'en, saa de ikke konkurrerer med det foerste billede om
     baandbredden — det foerste billede er sidens LCP. En lazy-billede i
     en display:none-slide bliver aldrig hentet af sig selv, og saa ville
     der staa et tomt felt, naar den slide kommer frem efter 8 sekunder.
     Derfor haenter vi dem selv, naar der er gaaet knap 2 sekunder og det
     foerste billede laengst er paa plads. */
  setTimeout(function(){
    [].forEach.call(kar.querySelectorAll('.lbfk-s:not(.paa) img'), function(im){
      im.loading = 'eager';
    });
  }, 1800);

  vis(0);
  start();
})();
